import { CissAutoComplete, CissAutoCompleteProps } from '../../../../../components/autocompletes/CissAutoComplete';

import { TipoRevendedor } from 'pages/revendedor/revendedor/types';

type TipoPessoaAutoComplete = Pick<CissAutoCompleteProps, 'size' | 'error' | 'multiple' | 'disabled' | 'sx' | 'onChange' | 'label' | 'name' | 'value'>;

export function TipoRevendedorAutoComplete({
    sx,
    size,
    value,
    error,
    name,
    multiple = false,
    disabled = false,
    onChange = () => {},
}: TipoPessoaAutoComplete) {
    return (
        <CissAutoComplete
            disableClearable
            sx={sx}
            size={size}
            name={name}
            value={value}
            error={error}
            onChange={onChange}
            disabled={disabled}
            multiple={multiple}
            label="Tipo de pessoa"
            requestOptions={{
                url: '/gestao/tiporevendedor',
                sort: [{ property: 'idTipoRevendedor', direction: 'ASC' }],
                limit: 50,
                nested: true,
            }}
            optionStringTemplate="{dsTipoRevendedor}"
            selectedStringTemplate="{dsTipoRevendedor}"
            isOptionEqualToValue={(option: TipoRevendedor, value: TipoRevendedor) => option.idTipoRevendedor === value.idTipoRevendedor}
        />
    );
}
